export enum SyncStatus {
    None = 'None',
    Running = 'Running',
    Completed = 'Completed',
    Failed = 'Failed',
}

export enum SyncType {
    Full = 'Full',
    Partial = 'Partial',
}

/**
 * How much a bridge extraction reads — a separate axis from {@link SyncType}, which says how much the backend
 * recomputes. Both Acomba modes read everything; only the missing-info retry reads less.
 */
export enum ReadScope {
    /** Every customer. The payload is authoritative about absences, so the backend may remove a relance. */
    Complete = 'Complete',
    /** Only what changed since the last sync. Says nothing about who is absent, so nothing may be removed. */
    TargetedRefresh = 'TargetedRefresh',
}

export enum SyncPhase {
    Preprocessing = 'Preprocessing',
    PriorityRanking = 'PriorityRanking',
    /** Ranking is done and the relances are still filling in. Home unblocks here; a follow-up page's veil lifts here too. */
    RelanceFill = 'RelanceFill',
}
